import React, { Component } from "react";
import { Row } from "simple-flexbox";
import InputComponent from "../../components/form/InputComponent";
// import SelectComponent from "../../components/form/SelectComponent";
import { StyleSheet, css } from "aphrodite";
import { connect } from "react-redux";
import SearchIcon from "@material-ui/icons/Search";
import _ from "lodash";

const styles = StyleSheet.create({
  container: {
    width: 200,
    marginLeft: 10,
  },
});
class SerkomModalAddHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serkom: "",
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.delayedQuery = this.delayedQuery.bind(this);
  }
  componentDidMount() {}

  delayedQuery = _.debounce((value) => {
    const { handleRefresh } = this.props;

    return handleRefresh(value);
  }, 500);

  handleSearchChange(e) {
    this.setState({ serkom: e.target.value });
    this.delayedQuery(e.target.value);
  }

  render() {
    const { selectedMembers } = this.props;
    return (
      <Row
        style={{ padding: "20px 0" }}
        // horizontal="space-between"
        vertical="center"
      >
        <div>
          <div className={css(styles.container)}>
            <InputComponent
              onChange={this.handleSearchChange}
              value={this.state.serkom}
              placeholder="Cari nama"
              startIcon={SearchIcon}
            />
          </div>
        </div>
        <div style={{ color: "#7F8388", fontSize: 16, marginLeft: 40 }}>
          {selectedMembers} orang dipilih
        </div>
      </Row>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(SerkomModalAddHeader);
